import { QuestionData, QuizData, QuizResponse } from "./QuizTopicCard"
import { ReactComponent as CheckIcon } from "resources/images/check.svg"
import { ReactComponent as CrossIcon } from "resources/images/cross.svg"

type QuizesListProps = {
    quizes: QuizResponse
}

export default function QuizesList({ quizes }: QuizesListProps) {
    return (
        <div>
            {quizes.data.map((q, index) => <QuizItem key={q.id} index={index + 1} quiz={q} />)}
        </div>
    )
}

type QuizItemProps = {
    quiz: QuizData
    index: number
}

function QuizItem({ quiz, index }: QuizItemProps) {
    return (
        <div className="my-5">
            <h5 className="is-size-5 mb-4">
                <strong>
                    Quiz #{index}
                </strong>
            </h5>
            {quiz.attributes.questions.data.map((question, index) => {
                return <QuestionItem index={index + 1} key={question.id} question={question} />
            })}
        </div>
    )
}


type QuestionItemProps = {
    question: QuestionData
    index: number,
}



function QuestionItem({ question, index }: QuestionItemProps) {
    return (
        <div className="question-item">
            {index}.{"  "}
            {question.attributes.question}
            <div className="options d-flex" style={{ flexWrap: "wrap" }}>
                {[1, 2, 3, 4].map(count => <Option
                    answer={question.attributes.answer}
                    user_answer={question.attributes.user_answer}
                    value={question.attributes[`option_${count}`] as string}
                />)}
            </div>
        </div>
    )
}


type OptionProps = {
    user_answer: string,
    answer: string,
    value: string
}

function Option({ user_answer, answer, value }: OptionProps) {
    let isUsersAnswer = value === user_answer
    let isUsersAnswerCorrect = user_answer === answer
    let isCorrectAnswer = value === answer
    return <div className={
        `option ${isCorrectAnswer ? "correct-answer" : ""} ${isUsersAnswer ? isUsersAnswerCorrect ? 'answered-correct' : 'answered-wrong' : ''}`
    }>
        <div className="correctness mr-2">
            {isUsersAnswer ? isCorrectAnswer ? <CheckIcon /> : <CrossIcon /> : null}
        </div>
        {value}
    </div>
}